export const CANONICAL_COLUMNS = {
  YEAR: "Year",
  MAKE: "Make",
  MODEL: "Model",
  PART_NAME: "PartName",
  PART_CATEGORY: "PartCategory",
  PRICE: "Price",
  QUANTITY: "Quantity",
  POSTAL_CODE: "PostalCode",
  DESCRIPTION: "DetailedDescription",
  STRIPE_LINK: "StripePaymentLink"
};

// Required columns for validation
export const REQUIRED_COLUMNS = [
  CANONICAL_COLUMNS.YEAR,
  CANONICAL_COLUMNS.MAKE,
  CANONICAL_COLUMNS.MODEL,
  CANONICAL_COLUMNS.PART_NAME,
  CANONICAL_COLUMNS.PART_CATEGORY,
  CANONICAL_COLUMNS.PRICE,
  CANONICAL_COLUMNS.QUANTITY,
  CANONICAL_COLUMNS.POSTAL_CODE
];

// Column name variations (handles typos, case sensitivity, spacing, etc.)
export const COLUMN_VARIATIONS = {
  [CANONICAL_COLUMNS.YEAR]: [
    "year",
    "Year",
    "YEAR",
    "yr",
    "Yr",
    "model year",
    "ModelYear",
    "model_year",
    "vehicle year",
    "VehicleYear"
  ],
  [CANONICAL_COLUMNS.MAKE]: [
    "make",
    "Make",
    "MAKE",
    "manufacturer",
    "Manufacturer",
    "brand",
    "Brand",
    "car make",
    "CarMake",
    "car_make"
  ],
  [CANONICAL_COLUMNS.MODEL]: [
    "model",
    "Model",
    "MODEL",
    "car model",
    "CarModel",
    "car_model",
    "vehicle model",
    "VehicleModel"
  ],
  [CANONICAL_COLUMNS.PART_NAME]: [
    "part name",
    "partname",
    "PartName",
    "PART NAME",
    "part_name",
    "PARTNAME",
    "name",
    "Name",
    "part",
    "Part",
    "product name",
    "ProductName",
    "product_name",
    "item name",
    "ItemName"
  ],
  [CANONICAL_COLUMNS.PART_CATEGORY]: [
    "part category",
    "partcategory",
    "PartCategory",
    "PART CATEGORY",
    "part_category",
    "PARTCATEGORY",
    "category",
    "Category",
    "type",
    "Type",
    "part type",
    "PartType",
    "part_type"
  ],
  [CANONICAL_COLUMNS.PRICE]: [
    "price",
    "Price",
    "PRICE",
    "cost",
    "Cost",
    "amount",
    "Amount",
    "unit price",
    "UnitPrice",
    "unit_price",
    "sale price",
    "SalePrice",
    "sale_price",
    "$",
    "price ($)"
  ],
  [CANONICAL_COLUMNS.QUANTITY]: [
    "quantity",
    "Quantity",
    "QUANTITY",
    "qty",
    "Qty",
    "QTY",
    "stock",
    "Stock",
    "amount",
    "Amount",
    "count",
    "Count",
    "available",
    "Available",
    "in stock",
    "InStock",
    "in_stock"
  ],
  [CANONICAL_COLUMNS.POSTAL_CODE]: [
    "postal code",
    "postalcode",
    "PostalCode",
    "POSTAL CODE",
    "postal_code",
    "POSTALCODE",
    "zip",
    "Zip",
    "ZIP",
    "zip code",
    "ZipCode",
    "zip_code",
    "postcode",
    "PostCode",
    "post_code"
  ],
  [CANONICAL_COLUMNS.DESCRIPTION]: [
    "detailed description",
    "detaileddescription",
    "DetailedDescription",
    "DETAILED DESCRIPTION",
    "detailed_description",
    "description",
    "Description",
    "DESCRIPTION",
    "desc",
    "Desc",
    "details",
    "Details",
    "notes",
    "Notes",
    "comments",
    "Comments"
  ],
  [CANONICAL_COLUMNS.STRIPE_LINK]: [
    "stripe payment link",
    "stripepaymentlink",
    "StripePaymentLink",
    "STRIPE PAYMENT LINK",
    "stripe_payment_link",
    "payment link",
    "PaymentLink",
    "payment_link",
    "stripe link",
    "StripeLink",
    "stripe_link",
    "checkout link",
    "CheckoutLink",
    "checkout_link",
    "payment url",
    "PaymentURL",
    "payment_url",
    "Stripe payment"
  ]
};
